import Vue from 'vue'
import Vuex from 'vuex'
import account from './account'
import common from './common'
import explore from './explore'
import search from './search'
import media from './media'
import profile from './profile'
import post from './post'
import suggestions from './suggestions'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        account: account,
        profile: profile,
        common: common,
        explore: explore,
        search: search,
        media: media,
        post: post,
        suggestions: suggestions
    }
})